const DELAY_IN_SECS = 0.1;

const quoteFormSettingsMock = {
  nothing: 'denothing',
};

// get a mock
const getQuoteFormSettings = async (...args) => {
  await new Promise((r) => setTimeout(r, DELAY_IN_SECS * 1000));
  return quoteFormSettingsMock;
};

export default getQuoteFormSettings;
